<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">安心购阶段：</span>
          <div style="width: 220px">
            <el-select v-model="query.inspectionFlowStatus" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="item in flowOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
          <div style="width: 220px">
            <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">买家昵称：</span>
          <div style="width: 130px">
            <el-input v-model="query.buyerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">卖家昵称：</span>
          <div style="width: 130px">
            <el-input v-model="query.sellerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <el-table
      class="secondhand-order-table"
      :data="tableData"
      border
      style="width: 100%; margin-top: 12px"
      v-loading="loading"
    >
      <el-table-column prop="orderNo" label="订单号" min-width="180" align="center" />
      <el-table-column label="订单状态" width="168" align="center">
        <template slot-scope="scope">
          <span :style="{ color: statusColor(scope.row.status, scope.row) }">{{ statusLabel(scope.row.status, scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="安心购服务" width="120" align="center">
        <template slot-scope="scope">{{ inspectionServiceTypeLabel(scope.row.inspectionServiceType) }}</template>
      </el-table-column>
      <el-table-column label="买家" width="200">
        <template slot-scope="scope">
          <div class="cell-user">
            <el-avatar :size="26" :src="scope.row.buyerPhoto"></el-avatar>
            <el-tooltip v-if="scope.row.buyerNickName" effect="dark" :content="scope.row.buyerNickName" placement="top">
              <span class="cell-user__name">{{ scope.row.buyerNickName }}</span>
            </el-tooltip>
            <span v-else class="cell-user__name">-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="卖家" width="200">
        <template slot-scope="scope">
          <div class="cell-user">
            <el-avatar :size="26" :src="scope.row.sellerPhoto"></el-avatar>
            <el-tooltip v-if="scope.row.sellerNickName" effect="dark" :content="scope.row.sellerNickName" placement="top">
              <span class="cell-user__name">{{ scope.row.sellerNickName }}</span>
            </el-tooltip>
            <span v-else class="cell-user__name">-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品" min-width="260">
        <template slot-scope="scope">
          <div class="cell-product">
            <div class="cell-product__img">
              <img v-if="scope.row.productImage" :src="scope.row.productImage" alt="" />
              <div v-else class="cell-product__img--empty">-</div>
            </div>
            <div class="cell-product__meta">
              <el-tooltip
                v-if="scope.row.productTitle"
                effect="dark"
                :content="scope.row.productTitle"
                placement="top-start"
              >
                <div class="cell-product__title">{{ scope.row.productTitle }}</div>
              </el-tooltip>
              <div v-else class="cell-product__title">-</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支付金额(元)" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
      </el-table-column>
      <el-table-column label="安心购费用(元)" width="130" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.inspectionFee) }}</template>
      </el-table-column>
      <el-table-column label="鉴别结论" width="96" align="center">
        <template slot-scope="scope">{{ inspectionResultShort(scope.row.inspectionResult) }}</template>
      </el-table-column>
      <el-table-column label="卖家鉴别费" min-width="118" align="center">
        <template slot-scope="scope">
          <template v-if="sellerFeeRowTag(scope.row)">
            <el-tag size="mini" :type="sellerFeeRowTag(scope.row).type">{{ sellerFeeRowTag(scope.row).text }}</el-tag>
          </template>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="cell-actions">
            <el-button size="small" @click="detailFn(scope.row)">详情</el-button>
            <el-button
              v-if="inspectionPrimaryAction(scope.row).code === 'CONFIRM_RECEIVE'"
              size="small"
              type="primary"
              plain
              :loading="inspectionOpsLoading"
              @click="centerConfirmReceiveRow(scope.row)"
            >平台确认收货</el-button>
            <el-button
              v-else-if="inspectionPrimaryAction(scope.row).code === 'START_INSPECT'"
              size="small"
              type="primary"
              plain
              :loading="inspectionOpsLoading"
              @click="centerStartInspectingRow(scope.row)"
            >开始鉴别</el-button>
            <el-button
              v-else-if="inspectionPrimaryAction(scope.row).code === 'REPORT'"
              size="small"
              type="primary"
              :loading="inspectionOpsLoading"
              @click="openPlatformIdentifyFromRow(scope.row)"
            >{{ inspectionPrimaryAction(scope.row).label }}</el-button>
            <el-button
              v-else-if="inspectionPrimaryAction(scope.row).code === 'SHIP_TO_BUYER'"
              size="small"
              type="success"
              :loading="shipToBuyerLoading"
              @click="openShipToBuyerDialog(scope.row)"
            >发货给买家</el-button>
            <el-button
              v-if="canShipBackToSeller(scope.row)"
              size="small"
              type="warning"
              plain
              :loading="shipBackToSellerLoading"
              @click="openShipBackToSellerDialog(scope.row)"
            >寄回卖家</el-button>
            <el-button
              v-if="canNotifySellerInspectionFee(scope.row)"
              size="small"
              type="danger"
              plain
              :loading="notifySellerFeeLoadingId === scope.row.id"
              @click="notifySellerInspectionFeeRow(scope.row)"
            >通知付鉴别费</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>

    <el-dialog title="订单详情" :visible.sync="detailVisible" width="920px" custom-class="secondhand-inspection-order-detail-dialog">
      <div v-if="detail" class="detail-dialog-body">
        <section class="detail-section detail-section--product">
          <div class="detail-product-card">
            <div class="detail-product-card__img-wrap">
              <el-image
                v-if="detail.productImage"
                class="detail-product-card__img"
                :src="detail.productImage"
                fit="cover"
                :preview-src-list="[detail.productImage]"
              />
              <div v-else class="detail-product-card__placeholder">暂无主图</div>
            </div>
            <div class="detail-product-card__meta">
              <div class="detail-product-card__title">{{ detail.productTitle || "—" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">订单信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">订单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.orderNo || "-" }}</span>
                <el-button v-if="detail.orderNo" class="detail-copy-btn" type="text" @click="copyText(detail.orderNo)">复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">订单状态</div>
              <div class="detail-field-value">
                <el-tag size="mini" :type="statusTagType(detail.status, detail)">{{ statusLabel(detail.status, detail) }}</el-tag>
                <span style="margin-left: 8px">
                  <el-tag size="mini" type="info">安心购</el-tag>
                </span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付金额(元)</div>
              <div class="detail-field-value">
                <span class="detail-money detail-money--primary">{{ formatMoney(detail.totalAmount) }}</span>
                <span style="margin-left: 10px">
                  <el-tag size="mini" :type="detail.isPay === 1 ? 'success' : 'warning'">{{ detail.isPay === 1 ? "已支付" : "未支付" }}</el-tag>
                </span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">商品价格(元)</div>
              <div class="detail-field-value"><span class="detail-money">{{ formatMoney(detail.price) }}</span></div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">运费(元)</div>
              <div class="detail-field-value"><span class="detail-money">{{ formatMoney(detail.freight) }}</span></div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">保证金(元)</div>
              <div class="detail-field-value"><span class="detail-money">{{ detail.deposit == null ? "-" : formatMoney(detail.deposit) }}</span></div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付时间</div>
              <div class="detail-field-value">{{ formatTime(detail.payTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付截止</div>
              <div class="detail-field-value">{{ formatTime(detail.payExpireTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">创建时间</div>
              <div class="detail-field-value">{{ formatTime(detail.createTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">确认收货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.confirmTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">更新时间</div>
              <div class="detail-field-value">{{ formatTime(detail.updateTime) }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full" v-if="detail.remark">
              <div class="detail-field-label">备注</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.remark }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">支付信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">微信交易单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.transactionId || "-" }}</span>
                <el-button v-if="detail.transactionId" class="detail-copy-btn" type="text" @click="copyText(detail.transactionId)">复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">交易单订单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.combineOutTradeNo || "-" }}</span>
                <el-button v-if="detail.combineOutTradeNo" class="detail-copy-btn" type="text" @click="copyText(detail.combineOutTradeNo)">复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">预支付ID</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.prepayId || "-" }}</span>
                <el-button v-if="detail.prepayId" class="detail-copy-btn" type="text" @click="copyText(detail.prepayId)">复制</el-button>
              </div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">安心购</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">当前阶段</div>
              <div class="detail-field-value">{{ inspectionFlowLabel(detail.inspectionFlowStatus) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">安心购费用(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.inspectionFee) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">交易规则</div>
              <div class="detail-field-value">{{ inspectionTradeRuleLabel(detail.inspectionTradeRule) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">验货费承担</div>
              <div class="detail-field-value">{{ inspectionFeePayerLabel(detail.inspectionFeePayer) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">安心购服务类型</div>
              <div class="detail-field-value">{{ inspectionServiceTypeLabel(detail.inspectionServiceType) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">批次号</div>
              <div class="detail-field-value">{{ secondhandBatchDisplay(detail) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">分装类型</div>
              <div class="detail-field-value">{{ secondhandSffzLabel(detail.sffz) }}</div>
            </div>
            <!-- 乙醇含量 / 标准乙醇：业务暂不在此页展示
            <div class="detail-field-cell">
              <div class="detail-field-label">乙醇含量 / 标准乙醇</div>
              <div class="detail-field-value">
                {{ (detail.ychl && String(detail.ychl).trim()) || "—" }} /
                {{ (detail.bzyc && String(detail.bzyc).trim()) || "—" }}
              </div>
            </div>
            -->
            <div class="detail-field-cell">
              <div class="detail-field-label">鉴别结论（综合）</div>
              <div class="detail-field-value">{{ inspectionResultLabel(detail.inspectionResult) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">外观鉴别</div>
              <div class="detail-field-value">{{ subInspectionResultLabel(detail.inspectionResultAppearance) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">液体鉴别</div>
              <div class="detail-field-value">{{ subInspectionResultLabel(detail.inspectionResultLiquid) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">报告出具时间</div>
              <div class="detail-field-value">{{ formatTime(detail.inspectionReportAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">报告</div>
              <div class="detail-field-value">
                <template v-if="detail.inspectionReportUrl">
                  <el-link :href="detail.inspectionReportUrl" target="_blank" type="primary">打开报告</el-link>
                  <el-button class="detail-copy-btn" type="text" @click="copyText(detail.inspectionReportUrl)">复制链接</el-button>
                </template>
                <template v-else>-</template>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">买家决策</div>
              <div class="detail-field-value">{{ inspectionDecisionLabel(detail.inspectionBuyerDecision) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">买家决策时间</div>
              <div class="detail-field-value">{{ formatTime(detail.inspectionBuyerDecisionAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">确认发货截止</div>
              <div class="detail-field-value">{{ formatTime(detail.inspectionBuyerConfirmDeadlineAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">买家确认发货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.inspectionBuyerConfirmShipAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家验货费支付</div>
              <div class="detail-field-value">{{ sellerPayInspectionLabel(detail.sellerPayInspectionStatus) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家验货费支付时间</div>
              <div class="detail-field-value">{{ formatTime(detail.sellerPayInspectionAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家应付鉴别费(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.sellerOwingInspectionFee) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家寄回地址确认</div>
              <div class="detail-field-value">{{ sellerReturnConfirmStatusLabel(detail.inspectionSellerReturnConfirmStatus) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">寄回地址确认截止</div>
              <div class="detail-field-value">{{ formatTime(detail.inspectionSellerReturnConfirmDeadlineAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">寄回地址确认时间</div>
              <div class="detail-field-value">{{ formatTime(detail.inspectionSellerReturnConfirmedAt) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">退款/售后状态</div>
              <div class="detail-field-value">{{ refundStatusLabel(detail.refundStatus) }}</div>
            </div>
          </div>
        </section>

        <section v-if="showInspectionIssueSection(detail)" class="detail-section">
          <h4 class="detail-section__title">异常 / 不符退回</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">说明</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.inspectionIssueDesc || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">鉴别中心（收货地址快照）</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">收货人</div>
              <div class="detail-field-value">{{ detail.inspectionCenterName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">{{ detail.inspectionCenterPhone || "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.inspectionCenterAddress || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">买卖双方</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">买家</div>
              <div class="detail-field-value detail-field-value--party">
                <el-avatar v-if="detail.buyerPhoto" class="detail-party-avatar" :size="36" :src="detail.buyerPhoto" />
                <span>{{ detail.buyerNickName || "-" }} / {{ detail.buyerName || "-" }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家</div>
              <div class="detail-field-value detail-field-value--party">
                <el-avatar v-if="detail.sellerPhoto" class="detail-party-avatar" :size="36" :src="detail.sellerPhoto" />
                <span>{{ detail.sellerNickName || "-" }} / {{ detail.sellerName || "-" }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">买家收货地址</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">收货人</div>
              <div class="detail-field-value">{{ buyerAddrSnap(detail).name || detail.buyerName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ buyerAddrSnap(detail).phone || detail.buyerPhone || "-" }}</span>
                <el-button
                  v-if="buyerAddrSnap(detail).phone || detail.buyerPhone"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(buyerAddrSnap(detail).phone || detail.buyerPhone)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ buyerAddrSnap(detail).full || detail.buyerAddress || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">卖家发货地址</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">寄件人</div>
              <div class="detail-field-value">{{ sellerAddrSnap(detail).name || detail.sellerName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ sellerAddrSnap(detail).phone || detail.sellerPhone || "-" }}</span>
                <el-button
                  v-if="sellerAddrSnap(detail).phone || detail.sellerPhone"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(sellerAddrSnap(detail).phone || detail.sellerPhone)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ sellerAddrSnap(detail).full || detail.sellerAddress || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">发货物流（卖家 → 买家，非中心段）</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">物流公司</div>
              <div class="detail-field-value">{{ detail.logisticsCompany || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">物流单号</div>
              <div class="detail-field-value">{{ detail.logisticsNo || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">发货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.shipTime) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">验货物流（卖家 → 鉴别中心）</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">快递公司</div>
              <div class="detail-field-value">{{ detail.sellerToCenterExpressCompany || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">快递单号</div>
              <div class="detail-field-value">{{ detail.sellerToCenterExpressNo || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">寄出时间</div>
              <div class="detail-field-value">{{ formatTime(detail.sellerToCenterShipTime) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">验货物流（鉴别中心 → 买家）</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">快递公司</div>
              <div class="detail-field-value">{{ detail.centerToBuyerExpressCompany || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">快递单号</div>
              <div class="detail-field-value">{{ detail.centerToBuyerExpressNo || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">发货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.centerToBuyerShipTime) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">验货物流（鉴别中心 → 卖家）</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">快递公司</div>
              <div class="detail-field-value">{{ detail.centerToSellerExpressCompany || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">快递单号</div>
              <div class="detail-field-value">{{ detail.centerToSellerExpressNo || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">发货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.centerToSellerShipTime) }}</div>
            </div>
          </div>
        </section>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="detail && detailPrimaryAction().code === 'CONFIRM_RECEIVE'"
          type="primary"
          plain
          :loading="inspectionOpsLoading"
          @click="centerConfirmReceiveOps"
        >平台确认收货</el-button>
        <el-button
          v-if="detail && detailPrimaryAction().code === 'START_INSPECT'"
          type="primary"
          plain
          :loading="inspectionOpsLoading"
          @click="centerStartInspectingOps"
        >开始鉴别</el-button>
        <el-button
          v-if="detail && detailPrimaryAction().code === 'REPORT'"
          type="primary"
          :loading="inspectionOpsLoading"
          @click="openPlatformIdentifyFromDetail"
        >{{ detailPrimaryAction().label }}</el-button>
        <el-button
          v-if="detail && detailPrimaryAction().code === 'SHIP_TO_BUYER'"
          type="success"
          :loading="shipToBuyerLoading"
          @click="openShipToBuyerDialog(detail)"
        >发货给买家</el-button>
        <el-button
          v-if="detail && canShipBackToSeller(detail)"
          type="warning"
          plain
          :loading="shipBackToSellerLoading"
          @click="openShipBackToSellerDialog(detail)"
        >寄回卖家</el-button>
        <el-button
          v-if="detail && canNotifySellerInspectionFee(detail)"
          type="danger"
          plain
          :loading="notifySellerFeeLoadingId === detail.id"
          @click="notifySellerInspectionFeeRow(detail)"
        >通知卖家支付鉴别费</el-button>
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 平台发货给买家（真品且买家确认后） -->
    <el-dialog title="发货给买家" :visible.sync="shipToBuyerVisible" width="520px">
      <el-form label-width="90px">
        <el-form-item label="物流公司">
          <el-select v-model="shipToBuyerForm.expressCompany" placeholder="请选择物流公司" filterable style="width: 100%">
            <el-option v-for="item in companyData" :key="item.code" :label="item.title" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="shipToBuyerForm.expressNo" placeholder="必填" maxlength="60" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipToBuyerVisible = false">取消</el-button>
        <el-button type="success" :loading="shipToBuyerLoading" @click="submitShipToBuyer">确认发货</el-button>
      </span>
    </el-dialog>

    <!-- 鉴别中心寄回卖家（假货/不符/真品买家拒绝等） -->
    <el-dialog title="寄回卖家" :visible.sync="shipBackToSellerVisible" width="520px">
      <el-form label-width="90px">
        <el-form-item label="物流公司">
          <el-select v-model="shipBackToSellerForm.expressCompany" placeholder="请选择物流公司" filterable style="width: 100%">
            <el-option v-for="item in companyData" :key="item.code" :label="item.title" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="shipBackToSellerForm.expressNo" placeholder="必填" maxlength="60" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipBackToSellerVisible = false">取消</el-button>
        <el-button type="success" :loading="shipBackToSellerLoading" @click="submitShipBackToSeller">确认寄回</el-button>
      </span>
    </el-dialog>

    <!-- 平台鉴别：参考鉴别订单的“平台鉴别”弹窗结构，分步出具报告；假货已出具后仅查看 -->
    <el-dialog :title="platformIdentifyReadOnly ? '查看鉴别' : '平台鉴别'" :visible.sync="platformIdentifyVisible" width="920px">
      <div
        v-loading="inspectionOpsLoading"
        class="platform-identify"
        :class="{ 'platform-identify--readonly-view': platformIdentifyReadOnly }"
      >
        <el-alert
          v-if="platformIdentifyReadOnly"
          type="info"
          :closable="false"
          show-icon
          style="margin-bottom: 12px"
          title="本单鉴别结论为假货（不通过），报告已生效，仅支持查看，不可修改或重新提交。"
        />
        <el-steps :active="platformIdentifyStep" finish-status="success" align-center>
          <el-step title="上传图谱/填写参数" />
          <el-step title="选择结果/上传报告" />
          <el-step title="提交出具" />
        </el-steps>

        <div style="height: 14px" />

        <template v-if="platformIdentifyStep === 0">
          <div style="height: 12px" />

          <el-alert type="info" :closable="false" show-icon style="margin-bottom: 12px">
            <template slot="title">
              <span>当前安心购服务：{{ inspectionServiceTypeLabel(detail && detail.inspectionServiceType) }}</span>
              <div class="platform-identify-service-sub">{{ inspectionServiceTypeHint(detail) }}</div>
            </template>
          </el-alert>

          <el-form class="platform-identify-form" label-width="110px">
            <el-form-item label="平台鉴别">
              <el-radio v-model="ptjbVle" v-removeAriaHidden :label="0" :disabled="platformIdentifyReadOnly">需要鉴别</el-radio>
              <el-radio v-model="ptjbVle" v-removeAriaHidden :label="1" style="margin-left: 16px" :disabled="platformIdentifyReadOnly">不符退回</el-radio>
              <div class="platform-identify-hint">
                需要鉴别：上传图谱并给出真/假结果；不符退回：直接判定不通过并走退回/退款逻辑
              </div>
            </el-form-item>

            <template v-if="ptjbVle === 0">
              <template v-if="inspectIdentifyProfile(detail).showLiquidBlock">
                <el-form-item label="标准图谱">
                  <div v-if="!platformIdentifyReadOnly" class="platform-identify-actions">
                    <uploadFile @getImg="onStdChartNoCoordUploaded" :isSlot="true">
                      <el-button type="success" size="small">更改无坐标图谱</el-button>
                    </uploadFile>
                    <uploadFile @getImg="onStdChartCoordUploaded" :isSlot="true">
                      <el-button type="success" size="small">更改有坐标图谱</el-button>
                    </uploadFile>
                  </div>
                  <div class="platform-identify-std-preview">
                    <div class="platform-identify-std-preview__item">
                      <div class="platform-identify-std-preview__label">无坐标图谱</div>
                      <div class="platform-identify-std-preview__thumb">
                        <el-image
                          v-if="stdChartNoCoord"
                          class="platform-identify-std-preview__img"
                          :src="stdChartNoCoord"
                          fit="contain"
                          :preview-src-list="[stdChartNoCoord]"
                        />
                        <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                      </div>
                    </div>
                    <div class="platform-identify-std-preview__item">
                      <div class="platform-identify-std-preview__label">有坐标图谱</div>
                      <div class="platform-identify-std-preview__thumb">
                        <el-image
                          v-if="stdChartCoord"
                          class="platform-identify-std-preview__img"
                          :src="stdChartCoord"
                          fit="contain"
                          :preview-src-list="[stdChartCoord]"
                        />
                        <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                      </div>
                    </div>
                  </div>
                  <div class="platform-identify-hint">
                    当前：无坐标 {{ stdChartNoCoord ? "已上传" : "未上传" }}；有坐标 {{ stdChartCoord ? "已上传" : "未上传" }}
                  </div>
                </el-form-item>

                <el-form-item label="鉴别图谱">
                  <div class="platform-identify-chart-mode">
                    <el-radio-group v-model="identifyChartUploadMode" size="small" :disabled="platformIdentifyReadOnly">
                      <el-radio-button label="image">上传图片</el-radio-button>
                      <el-radio-button label="txt">TXT 生成谱图</el-radio-button>
                    </el-radio-group>
                  </div>
                  <div v-if="!platformIdentifyReadOnly" class="platform-identify-jbtp-actions">
                    <template v-if="identifyChartUploadMode === 'image'">
                      <el-upload
                        class="platform-identify-jbtp-upload"
                        name="file"
                        :show-file-list="false"
                        :action="$api.api.uploadImg"
                        :on-success="onIdentifyChartUploaded"
                      >
                        <el-button type="success" size="small">{{ identifyList.jbtp ? "更换图片" : "上传图片" }}</el-button>
                      </el-upload>
                    </template>
                    <template v-else>
                      <el-button
                        type="primary"
                        size="small"
                        plain
                        :loading="identifyTxtGenerating"
                        @click="triggerIdentifySpectrumTxtPick"
                      >选择 TXT 并生成谱图</el-button>
                      <input
                        ref="identifySpectrumTxtInput"
                        type="file"
                        accept=".txt,text/plain"
                        class="platform-identify-txt-input"
                        @change="onIdentifySpectrumTxtSelected"
                      />
                    </template>
                  </div>
                  <div class="platform-identify-std-preview platform-identify-jbtp-preview-row">
                    <div class="platform-identify-std-preview__item">
                      <div class="platform-identify-std-preview__thumb">
                        <el-image
                          v-if="identifyList.jbtp"
                          class="platform-identify-std-preview__img"
                          :src="identifyList.jbtp"
                          fit="contain"
                          :preview-src-list="[identifyList.jbtp]"
                        />
                        <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!inspectIdentifyProfile(detail).requireJbtpWhenNormal" class="platform-identify-hint">外观鉴别档：可不传</div>
                </el-form-item>

                <!-- 乙醇含量 / 标准乙醇：暂不需要录入
                <el-form-item label="乙醇含量">
                  <el-input v-model="identifyList.ychl" placeholder="请输入" style="max-width: 360px" />
                </el-form-item>
                <el-form-item label="标准乙醇">
                  <el-input v-model="identifyBzyc" placeholder="可选" style="max-width: 360px" />
                </el-form-item>
                -->
              </template>

              <el-divider content-position="left">样品信息</el-divider>

              <el-form-item label="类型">
                <el-radio-group v-model.number="identifySffz" :disabled="platformIdentifyReadOnly">
                  <el-radio :label="0">分装</el-radio>
                  <el-radio :label="1">不分装</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="批次">
                <el-radio-group v-model.number="identifyType2" :disabled="platformIdentifyReadOnly">
                  <el-radio :label="0">有批次号</el-radio>
                  <el-radio :label="1">无批次号</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="identifyType2 === 0" label="批次号">
                <el-input v-model="identifyBatchNum" placeholder="请输入批次号" maxlength="120" style="max-width: 360px" :disabled="platformIdentifyReadOnly" />
              </el-form-item>

              <el-form-item v-if="identifySffz === 1" label="实物图片" class="platform-identify-real-form-item">
                <div class="platform-identify-real-strip">
                  <div v-for="s in realPictureSlots" :key="s.k" class="platform-identify-real-slot">
                    <div class="platform-identify-real-slot__cap">{{ s.label }}</div>
                    <div class="platform-identify-real-slot__box">
                      <template v-if="platformIdentifyReadOnly">
                        <el-image
                          v-if="identifyRealImg[s.k]"
                          class="platform-identify-real-slot__img"
                          :src="identifyRealImg[s.k]"
                          fit="cover"
                          :preview-src-list="identifyRealImgPreviewList"
                        />
                        <div v-else class="platform-identify-real-slot__empty">暂无</div>
                      </template>
                      <div v-else class="platform-identify-real-slot__upload">
                        <uploadFile :image="identifyRealImg[s.k]" @getImg="(path) => setIdentifyRealImg(s.k, path)" />
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </template>

            <template v-else>
              <el-form-item label="退回原因">
                <el-radio-group
                  v-model="issueDescChoice"
                  :disabled="platformIdentifyReadOnly"
                  class="issue-desc-radio-group"
                >
                  <el-radio
                    v-for="item in issueDescOptionList"
                    :key="item.value"
                    v-removeAriaHidden
                    :label="item.value"
                    class="issue-desc-radio"
                  >{{ item.label }}</el-radio>
                </el-radio-group>
                <el-input
                  v-if="issueDescChoice === issueDescCustomValue"
                  v-model="issueDescCustomText"
                  type="textarea"
                  :rows="3"
                  maxlength="120"
                  show-word-limit
                  placeholder="请填写具体退回原因"
                  :disabled="platformIdentifyReadOnly"
                  class="issue-desc-custom-input"
                />
              </el-form-item>
            </template>
          </el-form>
        </template>

        <template v-else-if="platformIdentifyStep === 1">
          <el-alert
            title="请按服务类型分别选择外观（及液体）鉴别结果；报告图片已改为非必填。"
            type="info"
            :closable="false"
            show-icon
          />
          <div style="height: 12px" />

          <div v-if="ptjbVle === 1" class="platform-identify-hint" style="margin-bottom: 8px">
            已选择「不符退回」，提交后综合结论为「不符退回/无法鉴别」，无需选择真/假。
          </div>

          <el-form v-else class="platform-identify-form" label-width="120px">
            <el-form-item label="外观鉴别结果">
              <el-radio v-model="jbjgAppearanceVle" v-removeAriaHidden :label="1" :disabled="platformIdentifyReadOnly">通过</el-radio>
              <el-radio v-model="jbjgAppearanceVle" v-removeAriaHidden :label="0" style="margin-left: 16px" :disabled="platformIdentifyReadOnly">不通过</el-radio>
            </el-form-item>
            <el-form-item
              v-if="String((detail && detail.inspectionServiceType) || '').trim() === 'liq_app'"
              label="液体鉴别结果"
            >
              <el-radio v-model="jbjgLiquidVle" v-removeAriaHidden :label="1" :disabled="platformIdentifyReadOnly">通过</el-radio>
              <el-radio v-model="jbjgLiquidVle" v-removeAriaHidden :label="0" style="margin-left: 16px" :disabled="platformIdentifyReadOnly">不通过</el-radio>
            </el-form-item>
          </el-form>
        </template>

        <template v-else>
          <el-alert
            :title="platformIdentifyReadOnly ? '以下为已出具并生效的鉴别信息（只读）。' : '确认信息无误后提交。提交后将写入安心购报告，并推进状态为“报告已出具”。'"
            :type="platformIdentifyReadOnly ? 'info' : 'warning'"
            :closable="false"
            show-icon
          />
          <div style="height: 12px" />
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="订单号">{{ detail && detail.orderNo }}</el-descriptions-item>
            <el-descriptions-item label="安心购服务">{{ inspectionServiceTypeLabel(detail && detail.inspectionServiceType) }}</el-descriptions-item>
            <template v-if="ptjbVle === 1">
              <el-descriptions-item label="综合结论" :span="2">不符退回/无法鉴别</el-descriptions-item>
              <el-descriptions-item label="退回原因" :span="2">{{ issueDescPreviewText }}</el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item label="外观鉴别">{{ jbjgAppearanceVle === 1 ? '通过' : '不通过' }}</el-descriptions-item>
              <el-descriptions-item
                v-if="String((detail && detail.inspectionServiceType) || '').trim() === 'liq_app'"
                label="液体鉴别"
              >{{ jbjgLiquidVle === 1 ? '通过' : '不通过' }}</el-descriptions-item>
              <el-descriptions-item label="鉴别结果">{{ previewCombinedInspectionShort }}</el-descriptions-item>
            </template>
            <el-descriptions-item label="批次">{{ previewIdentifyBatchLine }}</el-descriptions-item>
            <el-descriptions-item label="鉴别图谱">{{ identifyList.jbtp ? '已上传' : '未上传' }}</el-descriptions-item>
            <el-descriptions-item label="分装类型">{{ secondhandSffzLabel(identifySffz) }}</el-descriptions-item>
            <!-- <el-descriptions-item label="报告图片">{{ platformReportImg ? '已上传' : '未上传' }}</el-descriptions-item> -->
            <!-- <el-descriptions-item label="乙醇/标准乙醇">{{ (identifyList.ychl || '—') + ' / ' + (identifyBzyc || '—') }}</el-descriptions-item> -->
          </el-descriptions>
        </template>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="platformIdentifyStep > 0" @click="platformIdentifyStep -= 1">上一步</el-button>
        <el-button
          v-if="platformIdentifyStep < 2"
          type="primary"
          @click="nextPlatformIdentifyStep"
        >下一步</el-button>
        <el-button
          v-else-if="!platformIdentifyReadOnly"
          type="success"
          :loading="inspectionOpsLoading"
          @click="submitPlatformIdentify"
        >提交出具</el-button>
        <el-button @click="platformIdentifyVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";
import elUpload from "@/components/elUpload";
import expressInfo from "@/util/expressInfo";
import {
  SPECTRUM_TXT_MAX_POINTS,
  parseSpectrumTxt,
  downsampleSpectrumPairs,
  renderTxtSpectrumChartToDataUrlAsync,
} from "@/util/spectrumTxtChart";

/** 安心购 dict_label → 平台鉴别表单项与校验（与下单端 liq_app / app_only 一致） */
const INSPECTION_IDENTIFY_PROFILE = {
  liq_app: {
    /** 需要鉴别时是否必须上传样品鉴别图谱 */
    requireJbtpWhenNormal: true,
    // requireYchlWhenNormal: true, // 乙醇含量已下线录入
    /** 是否展示液相相关表单项（标准图谱、鉴别图谱；乙醇字段已下线） */
    showLiquidBlock: true,
    /** 不分装时是否强制四张实物图 */
    requireRealPictureWhenNotDecant: true,
  },
  app_only: {
    requireJbtpWhenNormal: false,
    // requireYchlWhenNormal: false,
    showLiquidBlock: false,
    requireRealPictureWhenNotDecant: true,
  },
};

/** 不符退回：退回原因「自定义」选项值 */
const ISSUE_DESC_CUSTOM = "__custom__";

export default {
  name: "SecondhandInspectionOrder",
  components: {
    uploadFile: elUpload,
  },
  data() {
    return {
      historyArr: ["闲置订单管理", "安心购订单"],
      loading: false,
      /** 发送「卖家付鉴别费」站内通知时的订单 id，用于按钮 loading */
      notifySellerFeeLoadingId: null,

      query: {
        useInspection: 1,
        inspectionFlowStatus: null,
        orderNo: "",
        buyerNickName: "",
        sellerNickName: "",
      },
      flowOptions: [
        { label: "全部", value: null },
        { label: "待卖家发货至鉴别中心", value: 0 },
        { label: "卖家已寄出，平台待收货", value: 1 },
        { label: "平台已收货，待开始鉴别", value: 2 },
        { label: "平台鉴别中(", value: 3 },
        { label: "报告已出具", value: 4 },
        { label: "买家确认发货(", value: 5 },
        { label: "平台已发货给买家", value: 6 },
        { label: "平台已寄回卖家", value: 7 },
        { label: "买家已确认收货", value: 8 },
      ],

      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      detailVisible: false,
      detail: null,

      inspectionOpsLoading: false,

      // 平台发货给买家（中心->买家）
      shipToBuyerVisible: false,
      shipToBuyerLoading: false,
      companyData: expressInfo.arr || [],
      shipToBuyerForm: {
        orderId: null,
        expressCompany: "shunfeng",
        expressNo: "",
      },

      shipBackToSellerVisible: false,
      shipBackToSellerLoading: false,
      shipBackToSellerForm: {
        orderId: null,
        expressCompany: "shunfeng",
        expressNo: "",
      },

      // 平台鉴别（参考鉴别订单）
      platformIdentifyVisible: false,
      /** 鉴别结论已为假货(2) 时，仅允许查看已出具内容，不可修改或重新提交 */
      platformIdentifyReadOnly: false,
      platformIdentifyStep: 0,
      ptjbVle: 0,
      jbjgAppearanceVle: 1,
      jbjgLiquidVle: 1,
      /** 不符退回：预设退回原因（单选） */
      issueDescChoice: "香水与下单信息不符",
      issueDescCustomText: "",
      issueDescCustomValue: ISSUE_DESC_CUSTOM,
      issueDescOptionList: [
        { value: "香水与下单信息不符", label: "香水与下单信息不符" },
        { value: "严重破损", label: "严重破损" },
        { value: "严重漏液", label: "严重漏液" },
        { value: "喷头损坏，无法取样", label: "喷头损坏，无法取样" },
        { value: ISSUE_DESC_CUSTOM, label: "自定义" },
      ],
      stdChartNoCoord: "",
      stdChartCoord: "",
      identifyList: {
        jbtp: "",
        // ychl: "", // 乙醇录入已注释
      },
      /** 鉴别图谱：image 直接上传；txt 由仪器导出文本生成 PNG 再上传 */
      identifyChartUploadMode: "image",
      identifyTxtGenerating: false,
      platformReportImg: "",
      // identifyBzyc: "",
      identifySffz: 1,
      identifyType2: 0,
      identifyBatchNum: "",
      identifyRealImg: {
        img1: "",
        img2: "",
        img3: "",
        img4: "",
      },
    };
  },
  computed: {
    previewIdentifyBatchLine() {
      if (Number(this.identifyType2) === 1) return "无（以最新批次比对）";
      const b = (this.identifyBatchNum || "").trim();
      return b || "—";
    },
    /** 平台鉴别步骤三预览：综合结论（与提交 inspectionResult 一致） */
    previewCombinedInspectionShort() {
      if (this.ptjbVle === 1) return "不符退回/无法鉴别";
      const st = String((this.detail && this.detail.inspectionServiceType) || "").trim();
      const appPass = this.jbjgAppearanceVle === 1;
      const liqPass = this.jbjgLiquidVle === 1;
      if (st === "liq_app") {
        return appPass && liqPass ? "通过" : "不通过";
      }
      return appPass ? "通过" : "不通过";
    },
    /** 不符退回：第三步预览 / 详情展示文案 */
    issueDescPreviewText() {
      if (this.issueDescChoice === ISSUE_DESC_CUSTOM) {
        const s = String(this.issueDescCustomText || "").trim();
        return s || "—";
      }
      const hit = this.issueDescOptionList.find((o) => o.value === this.issueDescChoice);
      if (hit) return hit.label;
      const s = String(this.issueDescChoice || "").trim();
      return s || "—";
    },
    /** 不分装实物四宫格：角标文案 */
    realPictureSlots() {
      return [
        { k: "img1", label: "正面" },
        { k: "img2", label: "背面" },
        { k: "img3", label: "顶图" },
        { k: "img4", label: "底图" },
      ];
    },
    /** 实物四图预览（查看鉴别）：任意一张可连览已上传的图 */
    identifyRealImgPreviewList() {
      const im = this.identifyRealImg || {};
      return ["img1", "img2", "img3", "img4"]
        .map((key) => (im[key] != null && String(im[key]).trim() ? String(im[key]).trim() : ""))
        .filter(Boolean);
    },
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isNaN(n) ? String(v) : n.toFixed(2);
    },

    statusTagType(v, row) {
      const x = Number(v);
      if (x === 0) return "warning";
      if (x === 4) return "success";
      if (x === 5 && row && Number(row.useInspection) === 1) {
        const sub = this.inspectionRefundedStatusLabel(row);
        if (sub && sub.indexOf("待卖家付") >= 0) return "danger";
        if (sub && sub.indexOf("待") >= 0) return "warning";
        if (sub && sub.indexOf("已寄回") >= 0) return "success";
      }
      if (x === 5 || x === 6) return "info";
      return "";
    },

    copyText(text) {
      const t = text == null ? "" : String(text);
      if (!t) return;
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(t)
          .then(() => this.$message.success("已复制"))
          .catch(() => this.fallbackCopyText(t));
        return;
      }
      this.fallbackCopyText(t);
    },

    fallbackCopyText(t) {
      try {
        const el = document.createElement("textarea");
        el.value = t;
        el.setAttribute("readonly", "readonly");
        el.style.position = "fixed";
        el.style.left = "-9999px";
        el.style.top = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.$message.success("已复制");
      } catch (e) {
        this.$message.warning("复制失败，请手动复制");
      }
    },

    safeJsonParse(str) {
      if (!str) return null;
      try {
        return JSON.parse(String(str));
      } catch (e) {
        return null;
      }
    },

    normalizeAddressSnapshot(o) {
      if (!o || typeof o !== "object") return { name: "", phone: "", full: "" };
      const pick = (keys) => {
        for (const k of keys) {
          const v = o[k];
          if (v != null && String(v).trim()) return String(v).trim();
        }
        return "";
      };
      const name = pick(["name", "userName", "receiverName", "consignee", "buyerName", "sellerName"]);
      const phone = pick(["phone", "mobile", "tel", "receiverPhone", "consigneePhone", "buyerPhone", "sellerPhone"]);
      const province = pick(["province", "provinceName"]);
      const city = pick(["city", "cityName"]);
      let district = "";
      if (Array.isArray(o.area)) {
        district = o.area.map((x) => String(x || "").trim()).filter(Boolean).join("");
      }
      if (!district) {
        district = pick(["area", "district", "districtName", "county", "countyName"]);
      }
      const detail = pick(["detail", "detailAddress", "addressDetail", "street", "addr", "address"]);
      const full = [province, city, district, detail].filter(Boolean).join("");
      return { name, phone, full };
    },

    buyerAddrSnap(d) {
      const o = this.safeJsonParse(d && d.buyerAddressJson);
      return this.normalizeAddressSnapshot(o);
    },

    sellerAddrSnap(d) {
      const o = this.safeJsonParse(d && d.sellerAddressJson);
      return this.normalizeAddressSnapshot(o);
    },

    /** 需平台寄回卖家：真品买家拒购 / 假货 / 不符退回 */
    needsSellerInspectionReturnToSeller(row) {
      if (!row || Number(row.useInspection) !== 1) return false;
      const r = Number(row.inspectionResult || 0);
      if (r === 2 || r === 3) return true;
      return r === 1 && Number(row.inspectionBuyerDecision || 0) === 2;
    },

    /** 安心购已退款(status=5)时的细分状态（含回寄卖家流程） */
    inspectionRefundedStatusLabel(row) {
      if (!row || Number(row.useInspection) !== 1) return null;
      const fs = Number(row.inspectionFlowStatus || 0);
      const ir = Number(row.inspectionResult || 0);
      const decision = Number(row.inspectionBuyerDecision || 0);
      const addrSt = row.inspectionSellerReturnConfirmStatus;
      const paySt = Number(row.sellerPayInspectionStatus || 0);
      const shippedBack = fs >= 7 || !!(row.centerToSellerExpressNo && String(row.centerToSellerExpressNo).trim());

      if (shippedBack) return "已退款·已寄回卖家";

      if (this.needsSellerInspectionReturnToSeller(row)) {
        if (ir === 2 && paySt === 1) return "已退款·待卖家付鉴别费";
        if (addrSt == null || Number(addrSt) === 0) return "已退款·待确认寄回地址";
        return "已退款·待平台寄回卖家";
      }

      if (ir === 1 && decision === 2) return "已退款·买家拒购";
      if (ir === 2) {
        if (paySt === 1) return "已退款·待卖家付鉴别费";
        return "已退款·验货不通过";
      }
      if (ir === 3) return "已退款·不符退回";
      return "已退款";
    },

    statusLabel(v, row) {
      const x = Number(v);
      const pendingFakeSellerFee =
        row &&
        Number(row.useInspection) === 1 &&
        Number(row.inspectionResult) === 2 &&
        Number(row.sellerPayInspectionStatus) === 1;
      // 终态优先：退款/取消/完成（安心购退款仍展示回寄等子状态）
      if (x === 5) {
        if (row && Number(row.useInspection) === 1) {
          return this.inspectionRefundedStatusLabel(row);
        }
        if (pendingFakeSellerFee) return "已退款·待卖家付鉴别费";
        return "已退款";
      }
      if (x === 6) return "已取消";
      if (x === 4) return "已完成";

      // 安心购：订单状态栏结合流程阶段展示（更贴近业务实际）
      if (row && Number(row.useInspection) === 1) {
        const fs = Number(row.inspectionFlowStatus || 0);
        if (fs === 0) return "待卖家寄往平台";
        if (fs === 1) return "待平台收货";
        if (fs === 2) return "待开始鉴别";
        if (fs === 3) return "平台鉴别中";
        if (fs === 4) return "待买家决策";
        if (fs === 5) return "待平台发货";
        if (fs === 6) return "已发货(待收货)";
        if (fs === 7) return "已寄回卖家";
        return "安心购处理中";
      }

      const m = { 0: "待支付", 1: "待发货", 2: "待收货", 3: "待评价", 4: "已完成", 5: "已退款", 6: "已取消" };
      return m[x] != null ? m[x] : String(v == null ? "-" : v);
    },

    statusColor(v, row) {
      const pendingFakeSellerFee =
        row &&
        Number(row.useInspection) === 1 &&
        Number(row.inspectionResult) === 2 &&
        Number(row.sellerPayInspectionStatus) === 1;
      if (Number(v) === 5 && row && Number(row.useInspection) === 1) {
        const sub = this.inspectionRefundedStatusLabel(row);
        if (sub && sub.indexOf("待卖家付") >= 0) return "#f56c6c";
        if (sub && sub.indexOf("待") >= 0) return "#e6a23c";
        if (sub && sub.indexOf("已寄回") >= 0) return "#67c23a";
      }
      if (Number(v) === 5 && pendingFakeSellerFee) return "#f56c6c";
      if (v === 0) return "#e6a23c";
      if (v === 4) return "#67c23a";
      if (v === 5 || v === 6 || v === 8) return "#909399";
      return "#333";
    },
    inspectionFlowLabel(v) {
      const x = Number(v || 0);
      if (x === 0) return "待卖家发货至鉴别中心";
      if (x === 1) return "平台待收货";
      if (x === 2) return "待开始鉴别";
      if (x === 3) return "平台鉴别中";
      if (x === 4) return "报告已出具";
      if (x === 5) return "买家确认发货";
      if (x === 6) return "已发货给买家";
      if (x === 7) return "已寄回卖家";
      if (x === 8) return "买家已确认收货";
      return "-";
    },
    inspectionResultLabel(v) {
      const x = Number(v || 0);
      if (x === 1) return "真品(通过)";
      if (x === 2) return "假货(不通过)";
      if (x === 3) return "不符退回/无法鉴别";
      return "-";
    },
    /** 列表「鉴别结论」列短文案 */
    inspectionResultShort(v) {
      const x = Number(v || 0);
      if (x === 1) return "真";
      if (x === 2) return "假";
      if (x === 3) return "退回";
      return "—";
    },
    /**
     * 假货关单后卖家待付/已付鉴别费：列表标签；非该场景返回 null
     */
    sellerFeeRowTag(row) {
      if (!row || Number(row.useInspection) !== 1) return null;
      if (Number(row.inspectionResult || 0) !== 2) return null;
      const s = Number(row.sellerPayInspectionStatus || 0);
      if (s === 1) {
        const raw = row.sellerOwingInspectionFee != null ? row.sellerOwingInspectionFee : row.inspectionFee;
        const m = this.formatMoney(raw);
        return { type: "danger", text: `待付¥${m}` };
      }
      if (s === 2) return { type: "success", text: "已付" };
      return null;
    },
    /** 分项：1 真 2 假；未录入展示为 — */
    subInspectionResultLabel(v) {
      if (v == null || v === "") return "—";
      const x = Number(v);
      if (Number.isNaN(x)) return "—";
      if (x === 1) return "真品(通过)";
      if (x === 2) return "假货(不通过)";
      return "—";
    },
    inspectionPrimaryAction(row) {
      const fs = Number((row && row.inspectionFlowStatus) || 0);
      if (fs === 1) return { code: "CONFIRM_RECEIVE", label: "平台确认收货" };
      if (fs === 2) return { code: "START_INSPECT", label: "开始鉴别" };
      if (fs === 3) return { code: "REPORT", label: "平台鉴别" };
      if (fs === 4) {
        const ir = Number((row && row.inspectionResult) || 0);
        if (ir === 2) {
          return { code: "REPORT", label: "查看鉴别" };
        }
        return { code: "REPORT", label: "查看/修改鉴别" };
      }
      if (fs === 5) return { code: "SHIP_TO_BUYER", label: "发货给买家" };
      return { code: "NONE", label: "" };
    },

    /** 与后端 adminNotifySellerInspectionFeeDue 条件一致：假货 + 卖家鉴别费待支付 */
    canNotifySellerInspectionFee(row) {
      if (!row) return false;
      return (
        Number(row.useInspection) === 1 &&
        Number(row.inspectionResult || 0) === 2 &&
        Number(row.sellerPayInspectionStatus || 0) === 1
      );
    },

    notifySellerInspectionFeeRow(row) {
      if (!row || !row.id) return;
      this.$confirm(
        "将向卖家发送站内通知（消息中心可见），提醒其前往订单支付鉴别费；支付完成后才可寄回商品。可重复发送。",
        "通知卖家支付鉴别费",
        { confirmButtonText: "发送", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          this.notifySellerFeeLoadingId = row.id;
          this.$https(this.$api.api.notifySellerInspectionFee, { orderId: row.id }, "POST")
            .then((res) => {
              if (res.data && res.data.code == 200) {
                this.$message.success("已发送");
                this.fetchList(this.currentPage);
                if (this.detailVisible && this.detail && this.detail.id === row.id) this.refreshDetail();
              } else {
                this.$message.error((res.data && res.data.msg) || "发送失败");
              }
            })
            .finally(() => {
              this.notifySellerFeeLoadingId = null;
            });
        })
        .catch(() => {});
    },

    /** 与后端 centerShipBackToSeller 门禁一致：可录入回寄物流 */
    canShipBackToSeller(row) {
      if (!row) return false;
      if (Number(row.useInspection) !== 1) return false;
      const r = Number(row.inspectionResult || 0);
      if (r === 1) {
        if (Number(row.inspectionBuyerDecision) !== 2) return false;
      } else if (r === 2) {
        if (Number(row.sellerPayInspectionStatus) !== 2) return false;
      } else if (r !== 3) {
        return false;
      }
      const addrSt = row.inspectionSellerReturnConfirmStatus;
      if (addrSt != null && Number(addrSt) === 0) return false;
      if (Number(row.inspectionFlowStatus) === 7) return false;
      if (row.centerToSellerExpressNo) return false;
      return true;
    },

    sellerReturnConfirmStatusLabel(v) {
      const x = Number(v);
      if (x === 0) return "待卖家确认寄回地址";
      if (x === 1) return "卖家已确认寄回地址";
      if (x === 2) return "超时已用默认寄回地址";
      return "—";
    },

    detailPrimaryAction() {
      return this.inspectionPrimaryAction(this.detail);
    },

    inspectionDecisionLabel(v) {
      const x = Number(v || 0);
      if (x === 1) return "已确认发货";
      if (x === 2) return "拒绝购买（退款）";
      return "未决";
    },

    sellerPayInspectionLabel(v) {
      const x = Number(v || 0);
      if (x === 1) return "待支付";
      if (x === 2) return "已支付";
      return "不适用";
    },

    inspectionTradeRuleLabel(v) {
      return Number(v) === 1 ? "买家必须走安心购" : "买家可选";
    },

    inspectionFeePayerLabel(v) {
      return Number(v) === 1 ? "卖家承担验货费" : "买家承担";
    },

    inspectionServiceTypeLabel(code) {
      const k = String(code || "").trim();
      if (k === "liq_app") return "外观+液体";
      if (k === "app_only") return "外观";
      return k || "—";
    },

    inspectionServiceTypeHint(row) {
      const k = String((row && row.inspectionServiceType) || "").trim();
      if (k === "liq_app") return "本档需填写液相相关图谱；不分装时请上传四张实物图。";
      if (k === "app_only") return "本档为外观鉴别：可不传鉴别图谱；不分装时请上传四张实物图。";
      return "未识别服务档时按外观鉴别处理。";
    },

    inspectIdentifyProfile(row) {
      const st = String((row && row.inspectionServiceType) || "").trim();
      return INSPECTION_IDENTIFY_PROFILE[st] || INSPECTION_IDENTIFY_PROFILE.app_only;
    },

    secondhandSffzLabel(sffz) {
      const n = Number(sffz);
      if (n === 1) return "不分装";
      if (n === 0) return "分装";
      return "—";
    },

    secondhandBatchDisplay(d) {
      if (!d) return "—";
      const t2 = d.type2 != null && String(d.type2) !== "" ? Number(d.type2) : null;
      if (t2 === 1) return "无（以最新批次比对）";
      const b = d.batchNum != null && String(d.batchNum).trim() !== "" ? String(d.batchNum).trim() : "";
      return b || "—";
    },

    inspectionIssueTypeLabel(v) {
      const m = { 1: "快递破损", 2: "泄漏/挥发", 3: "包装缺失", 4: "信息不足", 9: "其他" };
      const x = Number(v || 0);
      return m[x] || (x ? `类型${x}` : "-");
    },

    refundStatusLabel(v) {
      if (v == null) return "-";
      const x = Number(v);
      if (x === 4) return "已退款";
      if (x === 1 || x === 2) return "处理中";
      return String(x);
    },

    showInspectionIssueSection(d) {
      if (!d) return false;
      if (Number(d.inspectionResult || 0) === 3) return true;
      if (Number(d.inspectionIssueType || 0) > 0) return true;
      return !!(d.inspectionIssueDesc && String(d.inspectionIssueDesc).trim());
    },

    resetFn() {
      this.query = { useInspection: 1, inspectionFlowStatus: null, orderNo: "", buyerNickName: "", sellerNickName: "" };
      this.currentPage = 1;
      this.fetchList(1);
    },
    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },

    fetchList(page) {
      this.loading = true;
      const obj = {
        page: page || 1,
        size: this.pageSize,
        ...this.query,
      };
      this.$https(this.$api.api.selSecondhandOrder, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    detailFn(row) {
      if (!row || !row.id) return;
      this.detailVisible = true;
      this.detail = null;
      this.$https(this.$api.api.getSecondhandOrderById, { id: row.id }, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.detail = res.data.data;
        } else {
          this.$message.error((res.data && res.data.msg) || "加载订单失败");
        }
      });
    },

    centerConfirmReceiveRow(row) {
      if (!row || !row.id) return;
      this.inspectionOpsLoading = true;
      this.$https(this.$api.api.centerConfirmReceive, { orderId: row.id }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已确认收货");
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === row.id) this.refreshDetail();
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.inspectionOpsLoading = false;
        });
    },

    centerStartInspectingRow(row) {
      if (!row || !row.id) return;
      this.inspectionOpsLoading = true;
      this.$https(this.$api.api.centerStartInspecting, { orderId: row.id }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已开始鉴别");
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === row.id) this.refreshDetail();
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.inspectionOpsLoading = false;
        });
    },

    openPlatformIdentifyFromRow(row) {
      if (!row || !row.id) return;
      this.inspectionOpsLoading = true;
      this.$https(this.$api.api.getSecondhandOrderById, { id: row.id }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.detail = res.data.data;
            this.openPlatformIdentify();
          } else {
            this.$message.error((res.data && res.data.msg) || "加载订单失败");
          }
        })
        .finally(() => {
          this.inspectionOpsLoading = false;
        });
    },

    /**
     * 打开平台鉴别弹窗：标准图谱优先订单已存列，其次历史 JSON，再其次商品关联型号 Type.atlas1/atlas2
     */
    openPlatformIdentify() {
      if (!this.detail || !this.detail.id) return;
      const d = this.detail;
      const typeId = d.product && d.product.typeId;
      if (typeId) {
        this.$https(this.$api.api.selType, { id: typeId, page: 1, size: 1 }, "POST")
          .then((res) => {
            let a1 = "";
            let a2 = "";
            if (res.data && Number(res.data.code) === 200 && Array.isArray(res.data.data) && res.data.data.length) {
              const row = res.data.data[0];
              a1 = row.atlas1 != null ? String(row.atlas1).trim() : "";
              a2 = row.atlas2 != null ? String(row.atlas2).trim() : "";
            }
            this.applyPlatformIdentifyFormState(d, a1, a2);
          })
          .catch(() => {
            this.applyPlatformIdentifyFormState(d, "", "");
          });
      } else {
        this.applyPlatformIdentifyFormState(d, "", "");
      }
    },

    applyPlatformIdentifyFormState(d, typeAtlas1, typeAtlas2) {
      if (!d || !d.id) return;
      this.platformIdentifyReadOnly = Number(d.inspectionResult || 0) === 2;
      this.platformIdentifyStep = 0;
      this.platformReportImg = d.inspectionReportUrl || "";
      const appIr = d.inspectionResultAppearance;
      const liqIr = d.inspectionResultLiquid;
      if (appIr != null && (appIr === 1 || appIr === 2)) {
        this.jbjgAppearanceVle = appIr === 2 ? 0 : 1;
      } else {
        const ir = Number(d.inspectionResult || 0);
        this.jbjgAppearanceVle = ir === 2 ? 0 : 1;
      }
      if (liqIr != null && (liqIr === 1 || liqIr === 2)) {
        this.jbjgLiquidVle = liqIr === 2 ? 0 : 1;
      } else {
        const ir = Number(d.inspectionResult || 0);
        this.jbjgLiquidVle = ir === 2 ? 0 : 1;
      }
      this.ptjbVle = 0;
      this.issueDescChoice = this.issueDescOptionList[0].value;
      this.issueDescCustomText = "";

      let stdNo = (d.atlas1 && String(d.atlas1).trim()) || "";
      let stdCoord = (d.atlas2 && String(d.atlas2).trim()) || "";

      const payload = this.safeJsonParse(d.inspectionReportJson);
      if (payload && payload.schema === "platform_identify_v1") {
        if (payload.ptjb != null) this.ptjbVle = Number(payload.ptjb) === 1 ? 1 : 0;
        if (payload.issue && payload.issue.desc != null) {
          this.applyIssueDescFromSaved(payload.issue.desc);
        }
        const ch = payload.charts || {};
        if (!stdNo && ch.stdNoCoord) stdNo = String(ch.stdNoCoord).trim();
        if (!stdCoord && ch.stdCoord) stdCoord = String(ch.stdCoord).trim();
      } else if (Number(d.inspectionResult || 0) === 3) {
        this.ptjbVle = 1;
      }
      const issueDescLoadedFromJson =
        payload &&
        payload.schema === "platform_identify_v1" &&
        payload.issue &&
        payload.issue.desc != null;
      if (
        !issueDescLoadedFromJson &&
        d.inspectionIssueDesc != null &&
        String(d.inspectionIssueDesc).trim()
      ) {
        this.applyIssueDescFromSaved(d.inspectionIssueDesc);
      }
      if (!stdNo && typeAtlas1) stdNo = String(typeAtlas1).trim();
      if (!stdCoord && typeAtlas2) stdCoord = String(typeAtlas2).trim();
      this.stdChartNoCoord = stdNo;
      this.stdChartCoord = stdCoord;

      this.identifyList = {
        jbtp: (d.jbtp && String(d.jbtp).trim()) || "",
      };
      if (payload && payload.schema === "platform_identify_v1") {
        const ch = payload.charts || {};
        if (!this.identifyList.jbtp && ch.identify) {
          this.identifyList = { ...this.identifyList, jbtp: String(ch.identify) };
        }
      }

      this.identifySffz = d.sffz != null && String(d.sffz) !== "" ? Number(d.sffz) : 1;
      const hasBatch = d.batchNum != null && String(d.batchNum).trim() !== "";
      this.identifyType2 =
        d.type2 != null && String(d.type2) !== "" ? Number(d.type2) : 0;
      this.identifyBatchNum = hasBatch ? String(d.batchNum).trim() : "";

      const emptyReal = { img1: "", img2: "", img3: "", img4: "" };
      let real = { ...emptyReal };
      if (d.realpicture) {
        const rp = typeof d.realpicture === "object" ? d.realpicture : this.safeJsonParse(d.realpicture);
        if (rp && typeof rp === "object") {
          if (Array.isArray(rp)) {
            // 数组格式：转换为对象格式
            real.img1 = rp[0] != null && String(rp[0]).trim() ? String(rp[0]).trim() : "";
            real.img2 = rp[1] != null && String(rp[1]).trim() ? String(rp[1]).trim() : "";
            real.img3 = rp[2] != null && String(rp[2]).trim() ? String(rp[2]).trim() : "";
            real.img4 = rp[3] != null && String(rp[3]).trim() ? String(rp[3]).trim() : "";
          } else {
            // 对象格式
            ["img1", "img2", "img3", "img4"].forEach((k) => {
              if (rp[k] != null && String(rp[k]).trim()) real[k] = String(rp[k]).trim();
            });
          }
        }
      }
      this.identifyRealImg = real;

      this.identifyChartUploadMode = "image";
      this.identifyTxtGenerating = false;

      this.platformIdentifyVisible = true;
    },

    onStdChartNoCoordUploaded(path) {
      this.stdChartNoCoord = path;
    },
    onStdChartCoordUploaded(path) {
      this.stdChartCoord = path;
    },
    /** el-upload 默认 on-success 入参为接口 JSON 根对象，与 goodsOrder chartImgFn 一致：path 在 res.data.path */
    onIdentifyChartUploaded(res) {
      const p =
        (res && res.data && res.data.path) ||
        (res && res.data && res.data.data && res.data.data.path) ||
        "";
      if (p) this.$set(this.identifyList, "jbtp", p);
    },

    triggerIdentifySpectrumTxtPick() {
      const el = this.$refs.identifySpectrumTxtInput;
      if (el) el.click();
    },

    onIdentifySpectrumTxtSelected(ev) {
      const input = ev && ev.target;
      if (!input || !input.files || !input.files[0]) return;
      const file = input.files[0];
      input.value = "";
      const name = (file.name || "").toLowerCase();
      if (!name.endsWith(".txt")) {
        this.$message.warning("请选择 .txt 文本文件");
        return;
      }
      this.identifyTxtGenerating = true;
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const text = String(reader.result || "");
          const rawPts = parseSpectrumTxt(text);
          if (rawPts.length < 2) {
            this.identifyTxtGenerating = false;
            this.$message.error("未能从 TXT 中解析出有效数据点，请检查是否为两列数值格式");
            return;
          }
          const pts = downsampleSpectrumPairs(rawPts, SPECTRUM_TXT_MAX_POINTS);
          renderTxtSpectrumChartToDataUrlAsync(pts)
            .then((dataUrl) => this.uploadIdentifyChartFromDataUrl(dataUrl))
            .then(() => {
              this.$message.success("谱图已生成并上传");
            })
            .catch((e) => {
              this.$message.error((e && e.message) || "谱图生成或上传失败");
            })
            .finally(() => {
              this.identifyTxtGenerating = false;
            });
        } catch (err) {
          this.identifyTxtGenerating = false;
          this.$message.error((err && err.message) || "生成谱图失败");
        }
      };
      reader.onerror = () => {
        this.identifyTxtGenerating = false;
        this.$message.error("读取文件失败");
      };
      reader.readAsText(file, "UTF-8");
    },

    dataURLtoFile(base64Str, fileName) {
      const arr = base64Str.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },

    uploadIdentifyChartFromDataUrl(dataUrl) {
      return new Promise((resolve, reject) => {
        const no = new Date().valueOf() + "_" + Math.round(Math.random() * 1000);
        let imgFile;
        try {
          imgFile = this.dataURLtoFile(dataUrl, no + ".png");
        } catch (e) {
          reject(new Error("图片数据转换失败"));
          return;
        }
        const form = new FormData();
        form.append("file", imgFile);
        form.append("no", no);
        this.$https(this.$api.api.uploadImg, form, "POST")
          .then((res) => {
            const inner = res && res.data;
            const payload = inner && inner.data;
            const p = (payload && payload.path) || (inner && inner.path) || "";
            if (p) {
              this.$set(this.identifyList, "jbtp", p);
              resolve(p);
            } else {
              reject(new Error((inner && inner.msg) || "上传失败"));
            }
          })
          .catch(() => {
            reject(new Error("网络错误"));
          });
      });
    },

    onPlatformReportUploaded(path) {
      this.platformReportImg = path;
    },

    setIdentifyRealImg(key, path) {
      if (!key) return;
      this.$set(this.identifyRealImg, key, path || "");
    },

    onIdentifyRealImg1(path) {
      this.setIdentifyRealImg("img1", path);
    },
    onIdentifyRealImg2(path) {
      this.setIdentifyRealImg("img2", path);
    },
    onIdentifyRealImg3(path) {
      this.setIdentifyRealImg("img3", path);
    },
    onIdentifyRealImg4(path) {
      this.setIdentifyRealImg("img4", path);
    },

    resolveIssueDescForSubmit() {
      if (this.issueDescChoice === ISSUE_DESC_CUSTOM) {
        return String(this.issueDescCustomText || "").trim();
      }
      return String(this.issueDescChoice || "").trim();
    },

    applyIssueDescFromSaved(desc) {
      const s = desc != null ? String(desc).trim() : "";
      const hit = this.issueDescOptionList.find(
        (o) => o.value === s && o.value !== ISSUE_DESC_CUSTOM
      );
      if (hit) {
        this.issueDescChoice = hit.value;
        this.issueDescCustomText = "";
      } else if (s) {
        this.issueDescChoice = ISSUE_DESC_CUSTOM;
        this.issueDescCustomText = s;
      } else {
        this.issueDescChoice = this.issueDescOptionList[0].value;
        this.issueDescCustomText = "";
      }
    },

    nextPlatformIdentifyStep() {
      if (this.platformIdentifyReadOnly) {
        if (this.platformIdentifyStep < 2) {
          this.platformIdentifyStep += 1;
        }
        return;
      }
      if (this.platformIdentifyStep === 0) {
        if (this.ptjbVle === 1) {
          const desc = this.resolveIssueDescForSubmit();
          if (!desc) {
            this.$message.error(
              this.issueDescChoice === ISSUE_DESC_CUSTOM ? "请填写自定义退回原因" : "请选择退回原因"
            );
            return;
          }
          if (this.issueDescChoice === ISSUE_DESC_CUSTOM && desc.length > 120) {
            this.$message.error("自定义退回原因最多120字");
            return;
          }
        }
        const prof = this.inspectIdentifyProfile(this.detail);
        if (this.ptjbVle === 0) {
          if (prof.requireJbtpWhenNormal && !this.identifyList.jbtp) {
            this.$message.error("请先上传鉴别图谱");
            return;
          }
          // if (prof.requireYchlWhenNormal && !String(this.identifyList.ychl || "").trim()) {
          //   this.$message.error("请填写乙醇含量");
          //   return;
          // }
          if (Number(this.identifyType2) === 0 && !String(this.identifyBatchNum || "").trim()) {
            this.$message.error("请填写批次号，或选择「无批次号」");
            return;
          }
          if (prof.requireRealPictureWhenNotDecant && Number(this.identifySffz) === 1) {
            const im = this.identifyRealImg || {};
            if (!im.img1 || !im.img2 || !im.img3 || !im.img4) {
              this.$message.error("不分装时请上传四张实物图（正/背/顶/底）");
              return;
            }
          }
        }
      }
      // if (this.platformIdentifyStep === 1) {
      //   if (!this.platformReportImg) {
      //     this.$message.error("请先上传报告图片");
      //     return;
      //   }
      // }
      this.platformIdentifyStep += 1;
    },

    submitPlatformIdentify() {
      if (this.platformIdentifyReadOnly) {
        return;
      }
      if (!this.detail || !this.detail.id) return;
      // if (!this.platformReportImg) {
      //   this.$message.error("请先上传报告图片");
      //   return;
      // }
      const isMismatch = this.ptjbVle === 1;
      if (isMismatch) {
        const desc = this.resolveIssueDescForSubmit();
        if (!desc) {
          this.$message.error(
            this.issueDescChoice === ISSUE_DESC_CUSTOM ? "请填写自定义退回原因" : "请选择退回原因"
          );
          return;
        }
        if (this.issueDescChoice === ISSUE_DESC_CUSTOM && desc.length > 120) {
          this.$message.error("自定义退回原因最多120字");
          return;
        }
      }
      const st = String((this.detail && this.detail.inspectionServiceType) || "").trim();
      const inspectionResultAppearance = isMismatch ? null : (this.jbjgAppearanceVle === 1 ? 1 : 2);
      const inspectionResultLiquid =
        isMismatch || st !== "liq_app" ? null : (this.jbjgLiquidVle === 1 ? 1 : 2);
      // 不符退回：结论 3；否则外观+液体全真为 1，否则 2
      const inspectionResult = isMismatch
        ? 3
        : st === "liq_app"
          ? this.jbjgAppearanceVle === 1 && this.jbjgLiquidVle === 1 ? 1 : 2
          : (this.jbjgAppearanceVle === 1 ? 1 : 2);
      const payloadJson = {
        schema: "platform_identify_v1",
        ptjb: this.ptjbVle,
        issue: this.ptjbVle === 1 ? {
          type: 0,
          desc: this.resolveIssueDescForSubmit(),
        } : undefined,
        charts: {
          stdNoCoord: this.stdChartNoCoord || "",
          stdCoord: this.stdChartCoord || "",
          identify: this.identifyList.jbtp || "",
        },
        // ychl: this.identifyList.ychl || "",
        // bzyc: this.identifyBzyc || "",
        meta: {
          sffz: this.identifySffz,
          type2: this.identifyType2,
          batchNum: Number(this.identifyType2) === 1 ? "" : String(this.identifyBatchNum || "").trim(),
        },
      };
      const realpictureStr = JSON.stringify(this.identifyRealImg || {});
      this.inspectionOpsLoading = true;
      this.$https(this.$api.api.submitInspectionReport, {
        orderId: this.detail.id,
        inspectionResult,
        inspectionResultAppearance,
        inspectionResultLiquid,
        inspectionReportUrl: this.platformReportImg || "",
        inspectionReportJson: JSON.stringify(payloadJson),
        inspectionIssueType: this.ptjbVle === 1 ? 0 : null,
        inspectionIssueDesc: this.ptjbVle === 1 ? this.resolveIssueDescForSubmit() : null,
        atlas1: this.stdChartNoCoord || "",
        atlas2: this.stdChartCoord || "",
        jbtp: this.identifyList.jbtp || "",
        realpicture: realpictureStr,
        sffz: this.identifySffz,
        type2: this.identifyType2,
        batchNum: Number(this.identifyType2) === 1 ? "" : String(this.identifyBatchNum || "").trim(),
        // ychl: this.identifyList.ychl || "",
        // bzyc: this.identifyBzyc || "",
      }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已出具报告");
            this.platformIdentifyVisible = false;
            this.refreshDetail();
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "提交失败");
          }
        })
        .finally(() => {
          this.inspectionOpsLoading = false;
        });
    },

    openPlatformIdentifyFromDetail() {
      if (!this.detail || !this.detail.id) return;
      this.openPlatformIdentify();
    },

    refreshDetail() {
      if (!this.detail || !this.detail.id) return Promise.resolve();
      return this.$https(this.$api.api.getSecondhandOrderById, { id: this.detail.id }, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.detail = res.data.data;
        }
      });
    },

    openShipToBuyerDialog(row) {
      if (!row || !row.id) return;
      // 只允许在买家确认发货后操作（flow=5），其余状态不展示按钮，这里再做一次兜底
      const fs = Number(row.inspectionFlowStatus || 0);
      if (fs !== 5) {
        this.$message.warning("当前阶段不可发货给买家");
        return;
      }
      this.shipToBuyerForm = {
        orderId: row.id,
        expressCompany: "shunfeng",
        expressNo: "",
      };
      this.shipToBuyerVisible = true;
    },

    submitShipToBuyer() {
      const f = this.shipToBuyerForm || {};
      if (!f.orderId) return;
      const company = (f.expressCompany || "").trim();
      if (!company) {
        this.$message.error("请选择物流公司");
        return;
      }
      const no = (f.expressNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.shipToBuyerLoading = true;
      this.$https(
        this.$api.api.centerShipToBuyerAfterConfirm,
        { orderId: f.orderId, expressCompany: company, expressNo: no },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已发货给买家");
            this.shipToBuyerVisible = false;
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === f.orderId) this.refreshDetail();
          } else {
            this.$message.error((res.data && res.data.msg) || "发货失败");
          }
        })
        .finally(() => {
          this.shipToBuyerLoading = false;
        });
    },

    openShipBackToSellerDialog(row) {
      if (!row || !row.id) return;
      if (!this.canShipBackToSeller(row)) {
        this.$message.warning("当前不可寄回卖家（需卖家已确认寄回地址；假货另需已付鉴别费；真品需买家拒绝）");
        return;
      }
      this.shipBackToSellerForm = {
        orderId: row.id,
        expressCompany: "shunfeng",
        expressNo: "",
      };
      this.shipBackToSellerVisible = true;
    },

    submitShipBackToSeller() {
      const f = this.shipBackToSellerForm || {};
      if (!f.orderId) return;
      const company = (f.expressCompany || "").trim();
      if (!company) {
        this.$message.error("请选择物流公司");
        return;
      }
      const no = (f.expressNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.shipBackToSellerLoading = true;
      this.$https(
        this.$api.api.centerShipBackToSeller,
        { orderId: f.orderId, expressCompany: company, expressNo: no },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已提交回寄物流");
            this.shipBackToSellerVisible = false;
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === f.orderId) this.refreshDetail();
          } else {
            this.$message.error((res.data && res.data.msg) || "提交失败");
          }
        })
        .finally(() => {
          this.shipBackToSellerLoading = false;
        });
    },

    centerConfirmReceiveOps() {
      if (!this.detail || !this.detail.id) return;
      this.inspectionOpsLoading = true;
      this.$https(this.$api.api.centerConfirmReceive, { orderId: this.detail.id }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已确认收货");
            this.refreshDetail();
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.inspectionOpsLoading = false;
        });
    },

    centerStartInspectingOps() {
      if (!this.detail || !this.detail.id) return;
      this.inspectionOpsLoading = true;
      this.$https(this.$api.api.centerStartInspecting, { orderId: this.detail.id }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已开始鉴别");
            this.refreshDetail();
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.inspectionOpsLoading = false;
        });
    },

  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }

  .topLeft {
    align-items: center;
  }

  .page_box {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }

  /* 表格网格线更清晰（含固定列区域，scoped 下用 v-deep） */
  ::v-deep .secondhand-order-table.el-table--border,
  ::v-deep .secondhand-order-table.el-table--group {
    border: 1px solid #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table.el-table--border::after,
  ::v-deep .secondhand-order-table.el-table--group::after,
  ::v-deep .secondhand-order-table .el-table__fixed::before,
  ::v-deep .secondhand-order-table .el-table__fixed-right::before {
    background-color: #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table th.el-table__cell,
  ::v-deep .secondhand-order-table td.el-table__cell {
    border-right: 1px solid #c0c4cc !important;
    border-bottom: 1px solid #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table thead th.el-table__cell {
    background: #fafafa !important;
  }

  ::v-deep .secondhand-order-table .el-table__fixed-right {
    box-shadow: -1px 0 0 #c0c4cc !important;
  }

  .cell-user {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 2px 0;
  }

  .cell-user__name {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    line-height: 1.2;
  }

  .cell-product {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 2px 0;
  }

  .cell-product__img {
    width: 40px;
    height: 40px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
  }

  .cell-product__img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .cell-product__img--empty {
    color: #c0c4cc;
    font-size: 12px;
  }

  .cell-product__meta {
    min-width: 0;
    flex: 1;
  }

  .cell-product__title {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.2;
  }

  .cell-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  ::v-deep .cell-actions .el-button {
    width: 140px;
  }

  .detail-dialog-body {
    max-height: min(560px, calc(100vh - 200px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
    margin-right: -4px;
  }

  .detail-section {
    margin-bottom: 20px;
  }

  .detail-section__title {
    margin: 0 0 10px;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    border-left: 3px solid #409eff;
  }

  .detail-section--product {
    margin-bottom: 16px;
  }

  .detail-product-card {
    display: flex;
    align-items: stretch;
    gap: 16px;
    padding: 14px 16px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .detail-product-card__img-wrap {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
    background: #fff;
  }

  .detail-product-card__img {
    width: 96px;
    height: 96px;
    display: block;
  }

  .detail-product-card__placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #c0c4cc;
  }

  .detail-product-card__meta {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .detail-product-card__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.5;
    word-break: break-word;
  }

  .detail-field-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
  }

  /* 某些构建/作用域场景下，&--cols2 可能未正确覆盖，显式提高优先级 */
  .detail-field-box--cols2,
  .detail-field-box.detail-field-box--cols2 {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: row dense;
  }

  .detail-field-cell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: #fff;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    &--full {
      grid-column: 1 / -1;
      width: 100%;
    }
  }

  .detail-field-label {
    flex-shrink: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }

  .detail-field-value {
    flex: 1;
    min-width: 0;
    width: 100%;
    min-height: 36px;
    padding: 8px 10px;
    font-size: 13px;
    color: #303133;
    line-height: 1.5;
    word-break: break-all;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .detail-field-value--multiline {
    align-items: flex-start;
    white-space: pre-wrap;
  }

  .detail-field-value--party {
    gap: 10px;
  }

  .detail-party-avatar {
    flex-shrink: 0;
  }

  .detail-field-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    line-height: 1.4;
    color: #303133;
    word-break: break-all;
  }

  .detail-copy-btn {
    margin-left: 8px;
    padding: 0;
  }

  .detail-money {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  .detail-money--primary {
    font-size: 16px;
    color: #f56c6c;
  }

  .detail-collapse {
    width: 100%;
  }

  .detail-json {
    margin: 0;
    padding: 10px 12px;
    background: #0b1020;
    color: #e5e7eb;
    border-radius: 6px;
    overflow: auto;
    max-height: 220px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    line-height: 1.5;
  }

  /* 订单详情 - 安心购：报告一行的按钮不要挤压换行 */
  .detail-field-value .el-link {
    margin-right: 10px;
  }
}

/* 平台鉴别弹窗：统一布局，避免“挤在一起/宽度跳变” */
::v-deep .platform-identify {
  padding-top: 4px;
}

::v-deep .platform-identify-form {
  margin-top: 6px;
}

::v-deep .platform-identify-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

::v-deep .platform-identify-std-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

::v-deep .platform-identify-std-preview__item {
  min-width: 0;
}

::v-deep .platform-identify-std-preview__label {
  margin-bottom: 6px;
  font-size: 12px;
  color: #606266;
  line-height: 1.3;
}

::v-deep .platform-identify-std-preview__thumb {
  width: 120px;
  max-width: 100%;
  height: 90px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
  overflow: hidden;
}

::v-deep .platform-identify-std-preview__img {
  display: block;
  width: 100%;
  height: 100%;
}

::v-deep .platform-identify-std-preview__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 12px;
  color: #c0c4cc;
}

/* 查看鉴别（只读）：标准/鉴别图谱略缩；实物图见 .platform-identify-real-slot__*，与编辑态同一套方格逻辑 */
::v-deep .platform-identify--readonly-view .platform-identify-std-preview__thumb {
  width: 96px;
  height: 64px;
}

::v-deep .platform-identify-hint {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.platform-identify-chart-mode {
  margin-bottom: 10px;
}

.platform-identify-jbtp-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.platform-identify-jbtp-preview-row {
  margin-top: 10px;
}

::v-deep .platform-identify-jbtp-upload {
  display: inline-block;
}

.platform-identify-txt-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

::v-deep .platform-identify-report {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

::v-deep .platform-identify-report-uploader {
  width: 140px;
  height: 140px;
}

.platform-identify-service-sub {
  margin-top: 4px;
  font-size: 12px;
  font-weight: normal;
  color: #606266;
  line-height: 1.45;
}

::v-deep .platform-identify-real-form-item.el-form-item {
  align-items: flex-start;
}

::v-deep .platform-identify-real-form-item .el-form-item__label {
  padding-top: 0;
  line-height: 20px;
  align-self: flex-start;
}

::v-deep .platform-identify-real-form-item .el-form-item__content {
  line-height: normal !important;
  padding-top: 0;
  margin-top: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0 !important;
  min-height: 0 !important;
  overflow-x: auto;
  overflow-y: visible;
}

/* 不分装实物四图：与标准图谱样式隔离，避免 el-image / 占位互相串样式 */
::v-deep .platform-identify-real-strip {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

/* 实物四格：固定 96×96（与历史 upload 方格一致），不用 aspect-ratio，避免上传后高度随图片重算导致样式跳变 */
::v-deep .platform-identify-real-slot {
  flex: 0 0 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

::v-deep .platform-identify-real-slot__cap {
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #606266;
  line-height: 1.2;
  white-space: nowrap;
}

::v-deep .platform-identify-real-slot__box {
  position: relative;
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  margin: 0 auto;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  overflow: hidden;
}

::v-deep .platform-identify-real-slot__img.el-image {
  position: absolute !important;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
}

::v-deep .platform-identify-real-slot__img .el-image__inner {
  object-fit: cover !important;
}

::v-deep .platform-identify-real-slot__empty {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #c0c4cc;
  background: #fafafa;
}

::v-deep .platform-identify-real-slot__upload {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

::v-deep .platform-identify-real-slot__upload > div {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  box-sizing: border-box !important;
}

::v-deep .platform-identify-real-slot__upload .bannerBox {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 0;
  overflow: hidden;
}

::v-deep .platform-identify-real-slot__upload .bannerImg.el-upload,
::v-deep .platform-identify-real-slot__upload .bannerBox > .el-upload {
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  min-height: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  font-size: 12px !important;
  overflow: hidden;
}

::v-deep .platform-identify-real-slot__upload .avatar {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: cover !important;
  display: block;
}

::v-deep .platform-identify-real-slot__upload .avatar-uploader-icon {
  font-size: 26px !important;
  line-height: 1 !important;
}

::v-deep .platform-identify-real-slot__upload .bannerImg span {
  font-size: 12px !important;
  line-height: 1.2 !important;
}

.issue-desc-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  max-width: 560px;
}

.issue-desc-radio {
  display: block;
  margin-right: 0;
  line-height: 1.5;
  white-space: normal;
}

.issue-desc-custom-input {
  margin-top: 12px;
  max-width: 560px;
}
</style>

<!-- 覆盖 elUpload.vue 全局 .bannerBox .el-upload（实物四格 upload 容器为 real-slot__upload） -->
<style lang="less">
.platform-identify .platform-identify-real-slot__upload .bannerBox .el-upload {
  width: 96px !important;
  height: 96px !important;
  min-width: 0 !important;
  min-height: 0 !important;
  max-width: 96px !important;
  max-height: 96px !important;
  margin: 0 !important;
  font-size: 12px !important;
  line-height: 1 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

.platform-identify .platform-identify-real-slot__upload .bannerBox .el-upload img {
  width: 96px !important;
  height: 96px !important;
  max-width: 96px !important;
  max-height: 96px !important;
  object-fit: cover !important;
}

.platform-identify .platform-identify-real-strip {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: flex-start !important;
  width: 100% !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/secondhandInspectionOrder/index.vue